import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import "../../styles/alert.css";

export const AppAlert = ({
    caption,
    message,
    accept,
    reject,
    onAccept,
    onReject,
    onClose
}) => {
    return (
        <div className="alert-bg">
            <div className="alert-container">

                <div className={classNames('alert-cap', 'alert-row')}>
                    {caption}
                    <div className={classNames("alert-row", "close-box")}>
                        <button
                            className={classNames('red-btn', 'btn')}
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faClose} />
                        </button>
                    </div>
                </div>
                <div className={classNames('alert-row')}>{message}</div>
                <div className={classNames('alert-row', 'flx-r','c-j')}>
                    {accept && (
                        <button 
                            className={classNames("alert-action",'ac')} 
                            onClick={onAccept}
                        >
                            {accept}
                        </button>
                    )}
                    {reject && (
                        <button className="alert-action" onClick={onReject}>
                            {reject}
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}